import { EditButton } from "../../../components/Buttons/index.js";
import { FilesListDisplay } from "../../Files/shared/FilesListDisplay.js";
import "react";
import { Card, RichTextEditorDisplayContent } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/modules/Locations/shared/InfoBlockCard.tsx
function InfoBlockCard({ infoBlock, onEdit }) {
	return /* @__PURE__ */ jsxs(Card, { children: [
		/* @__PURE__ */ jsxs("div", { children: [/* @__PURE__ */ jsxs("div", {
			className: "inline-flex w-full items-center justify-between",
			children: [/* @__PURE__ */ jsx("h4", {
				className: "text-lg",
				children: infoBlock.title
			}), onEdit && /* @__PURE__ */ jsx(EditButton, { onClick: onEdit })]
		}), /* @__PURE__ */ jsx("div", { className: "mt-xs border-border border-t" })] }),
		/* @__PURE__ */ jsx("div", {
			className: "mt-base",
			children: infoBlock.bodyHtml ? /* @__PURE__ */ jsx(RichTextEditorDisplayContent, { html: infoBlock.bodyHtml }) : /* @__PURE__ */ jsx("div", {
				className: "whitespace-pre-wrap",
				children: infoBlock.body
			})
		}),
		/* @__PURE__ */ jsx("div", {
			className: "mt-xl",
			children: /* @__PURE__ */ jsx(FilesListDisplay, { fileUrls: infoBlock.fileUrls })
		})
	] });
}
//#endregion
export { InfoBlockCard };

//# sourceMappingURL=InfoBlockCard.js.map